export default "__VITE_ASSET__CLqqEp26__"